import { type CSSProperties, useMemo } from 'react'

import FractionalCircle from './FractionalCircle'
import { useExpiration } from './helpers'
import { CirclePreset, PresetNames, presets } from './presets'

import styles from './countdown.module.css'

interface Props {
  duration: number
  expireTime: Date
  runningClass?: string
  stopped?: boolean
  preset?: PresetNames | CirclePreset
}

const DurationTimer = ({
  duration,
  expireTime,
  runningClass,
  stopped,
  preset = 'default'
}: Props) => {
  const { timeToExpiration, displayTime, fraction } = useExpiration(
    duration,
    expireTime,
    stopped
  )

  const selectedPreset = useMemo(() => {
    if (typeof preset === 'string') {
      return presets[preset]
    }
    return preset
  }, [preset])

  const styleOverrides = useMemo(() => {
    return {
      '--r': `${selectedPreset.circle.r}px`,
      '--timerFontSize': selectedPreset.fontSize
    } as CSSProperties
  }, [selectedPreset])

  const cls = timeToExpiration > 0 && !stopped ? runningClass : ''
  return (
    <div className={`${styles.timerContainer} ${cls}`} style={styleOverrides}>
      <FractionalCircle preset={selectedPreset} fraction={fraction} />
      <span>{displayTime}</span>
    </div>
  )
}

export default DurationTimer
